import React, { useContext, useEffect, useState } from "react";
import "./styles.css";
import { Images } from "../../theme";
import { MapLocation } from "../";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

export default function ProductLocationCard(props) {
  const userContextData = useContext(AuthContext);
  let { loginData } = userContextData;
  let navigate = useNavigate();

  return (
    <>
      <div className="col-lg-7">
        <div className="row">
          <div className="col-md-12">
            {props.data?.map((val, index) => {
              return (
                <div
                  className="row mainBoxShadowNew mb-3"
                  onClick={() =>
                    navigate("/ProductDetail", {
                      state: { item: val, categoryData: props.categoryData },
                    })
                  }
                >
                  <div className="col-md-6 col-12">
                    <img
                      src={
                        val.images?.length
                          ? `${props.imageUrl}${val.images[0]}`
                          : Images.productImg
                      }
                      alt="image"
                      className="imgOwnProduct"
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <span className="OwnerHeading">
                      {val.firstname} {val.lastname}
                    </span>
                    <br />
                    <span className="OwnerProduct">{val.title}</span>
                    <p className="OwnerHeading">.</p>
                    <div>
                      <img
                        className="locationIconNewList"
                        src={Images.locationIcon}
                        alt="image"
                      />
                      <span className="OwerlocationTextNewList">
                        {val.location}
                      </span>
                      <p className="priceRentals">
                        ${val.daily_price}
                        <div className="ratingNewList">
                          <img src={Images.ratingIcon} alt="image" />
                          <span className="ratingOwerText">
                            {val.rating ? val.rating : 0}
                          </span>
                        </div>
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="col-lg-5 mb-4 newLocationImg">
        {props.locationData?.lat ? (
          <MapLocation data={props.locationData} zoom={11} />
        ) : null}
        {/* <img style={{ width: "100%" }} src={Images.MapImg} alt="image" /> */}
      </div>
    </>
  );
}
